export const toCommaDecimal = (value: number, decimals: number = 2) => {
    return value.toLocaleString("fi", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}


// WEBPACK FOOTER //
// ./src/utils/numberUtils.ts